import {
  PRIOR_AUTH_DEFAULT_CLINIC_ID,
  RESET_UNATTENDED_PRIOR_AUTH
} from './Index';

export const _setPriorAuthDefaultClinicIdAndFilters = ({
  clinicId,
  filters
}: {
  clinicId: number | null;
  filters: any;
}): any => async (dispatch: any) => {
  dispatch({
    type: PRIOR_AUTH_DEFAULT_CLINIC_ID,
    payload: {
      priorAuthDefaultClinicId: clinicId,
      priorAuthDefaultFilters: filters || null
    }
  });
};

export const _ResetPriorAuthDefaultClinicIdAndFilters = (): any => async (
  dispatch: any
) => {
  dispatch({
    type: RESET_UNATTENDED_PRIOR_AUTH,
    payload: {
      priorAuthDefaultClinicId: null,
      priorAuthDefaultFilters: null
    }
  });
};
